import { WithSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#has-pseudo}
 */
export class Has extends WithSelector {
    static of(selector) {
        return new Has(selector);
    }
    constructor(selector) {
        super("has", selector, selector.specificity);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    equals(value) {
        return value instanceof Has && value._selector.equals(this._selector);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (Has) {
    // :has() normally only accepts relative selectors, we currently
    // accept only non-relative ones…
    Has.parse = (parseSelector) => WithSelector.parseWithSelector("has", parseSelector, Has.of);
})(Has || (Has = {}));
//# sourceMappingURL=has.js.map